<style lang="less">
  @import "./main.less";
  .styleval{ display: table-cell; margin-right: 12px; width: 45px;height:45px; border-radius: 3px; line-height: 45px; text-align: center; color:#fff; font-size: 22px; }
  .stylevalO{ background: #7CB7E8 ;}
  .stylevalB{background: #242939 }
</style>
<template>
  <!-- <div class="main" :class="{'main-hide-text': shrink,'Bstyle':styleclass==1,'Ostyle':styleclass==0,}"> -->
  <div class="main" :class="{'main-hide-text': shrink}">

    <div class="single-page-con" :class="{'content-full':this.$store.state.app.indextrue}" style="left:0">
      <div class="single-page">
          <router-view ></router-view>
      </div>
    </div>
  </div>
</template>
<script>

  import Cookies from 'js-cookie';
  import util from '@/libs/util.js';

  export default {
    components: {
    },
    data() {
      ///验证再次输入密码
      const newPasswordzc=(rule, value, callback)=>{



          if (value === '') {
                    callback(new Error('请再次输入新密码'));
                } else if (value !== this.passwordForm.newPassword) {
                    callback(new Error('输入的新密码不一致'));
                } else {
                    callback();
                }
      };
      return {
        styleclass:0,
        shrink: false,
        userName: '',
        realName:"",
        roleName: '',
        typeName: '',
        nowTime: '',
        //修改密码弹出框
        passwordModal:false,
        //修改主题色弹出框
        styleModal:false,
        passwordForm:{
          oldPassword:"",
          newPassword:"",
          passwordx:""
        },
        // 判断是否全屏
        isFull: false,
        userType:null
      };
    },
    computed: {
      currentOpenedTag() {
        return this.$store.state.app.currentOpenedTag; // 当前面包屑数组
      },
      menuTheme() {
        return this.$store.state.app.menuTheme;
      },
      cachePage () {
          return this.$store.state.app.mainCachePage;
      }
    },
    methods: {
      init() {
        this.userName = Cookies.get('user');
        this.realName= window.localStorage.getItem('realName');
        this.roleName= window.localStorage.getItem('roleName');
        this.typeName= window.localStorage.getItem('typeName');

      },








    },
    watch: {
      '$route'(to) {
        this.$store.commit('addOpenedTags', to);
        this.$store.commit('addOpenSubmenu', this.$router.currentRoute.path);
      },
    },
    mounted() {
      this.init();
      this.userType=window.localStorage.getItem('userType')




    },
    created() {
      // 显示已打开的页面的标签列表
      // this.$store.commit('initOpenedTags');
      // 添加当前页面到标签列表
      // this.$store.commit('addOpenedTags', this.$router.currentRoute);
      // document.getElementsByTagName('body')[0].className = 'Ostyle'
      // 更新侧边栏列表
      // this.$store.commit('updateMenulist');
      // 展开级别、选中栏
      // this.$store.commit('addOpenSubmenu', this.$router.currentRoute.path);
      // this.getAreaTree();
       this.$store.state.app.showarea= {
            areaId: window.localStorage.getItem('areaId'),
            cityId: window.localStorage.getItem('cityId'),
            provinceId: window.localStorage.getItem('provinceId'),
        }
      let showcityname=window.localStorage.getItem('showcityname')
      history.pushState(null, null, document.URL);
      this.$store.state.app.showcityname=showcityname
      this.$store.state.app.level=window.localStorage.getItem('level')

      this.$store.state.app.showareaname= {
            areaName: window.localStorage.getItem('areaName'),
            cityName: window.localStorage.getItem('cityName'),
            provinceName: window.localStorage.getItem('provinceName'),
        }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/main.vue